export default __webpack_public_path__ + "static/media/Alpha_Corpay_Verticle.e683524a.png";